var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 14.4445V5.55562C4.1665 4.82265 4.1665 4.45617 4.32075 4.2393C4.45537 4.05002 4.66287 3.92554 4.89323 3.89583C5.15692 3.86182 5.47961 4.03392 6.12513 4.3782L6.12695 4.37917L14.4603 8.82362C15.1765 9.20561 15.5346 9.39664 15.652 9.65096C15.7542 9.87251 15.7542 10.1277 15.652 10.3492C15.5346 10.6035 15.1765 10.7946 14.4603 11.1766L6.12695 15.621L6.12466 15.6222C5.47945 15.9663 5.15686 16.1384 4.89323 16.1044C4.66287 16.0747 4.45537 15.9502 4.32075 15.7609C4.1665 15.544 4.1665 15.1775 4.1665 14.4445Z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.49455d97f8c87ce366159c60722346af.svg";
export { ForwardRef as ReactComponent };